import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { Table } from "react-bootstrap";

const GenericTable = ({ data }) => {
  const getHeaders = () => {
    return data.headers.map((row, index) => {
      return (
        <th key={index} className="text-center">
          {row}
        </th>
      );
    });
  };

  const getRowsData = () => {
    return data.rows.map((row, index) => {
      return (
        <React.Fragment key={index}>
          <tr>
            <td className="text-center">{row.label}</td>
            {row.values.map((value, idx) => {
              return (
                <td key={idx} className="text-center">
                  {value}
                </td>
              );
            })}
          </tr>
        </React.Fragment>
      );
    });
  };

  return (
    <>
      <Table bordered size="sm">
        <thead>
          <tr>{getHeaders()}</tr>
        </thead>
        <tbody>{getRowsData()}</tbody>
      </Table>
    </>
  );
};

export default GenericTable;
